import { Container } from "react-bootstrap";

import { useTranslation } from 'react-i18next';

import BotonWhatsapp from "./BotonWhatsapp";


const Footer = ({ datos, lang, ruta, logos_pie, websgrupo }) => {

    const { t } = useTranslation();

    var currentTime = new Date();
    var year = currentTime.getFullYear();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <footer className={"footer bg-white pt-5 potblur"}>
                <Container>
                    <div className="row justify-content-center">
                        <div className="col-md-2">
                            {
                                datos.logo !== "" ?
                                    <img
                                        className="logo-footer"
                                        alt={datos.nombre_comercial}
                                        title={datos.nombre_comercial}
                                        src={ruta + "/web/logo/web/" + datos.logo}
                                    />
                                    :
                                    datos.logo_fiscal != "" ?
                                        <img
                                            className="logo-footer"
                                            alt={datos.nombre_comercial}
                                            title={datos.nombre_comercial}
                                            src={ruta + "/web/logo/" + datos.logo_fiscal}
                                        />
                                        :
                                        <img
                                            className="logo-footer"
                                            alt="BedLoop"
                                            title="BedLoop"
                                            src="https://www.bedloop.com/imatges/logo.webp"
                                        />
                            }
                        </div>
                        <div className="col-md-8">
                            <ul className="list-inline">
                                <li className="list-inline-item">{datos.nombre_comercial}</li>
                                <li className="list-inline-item">{datos.nombre_fiscal}</li>
                                <li className="list-inline-item">{datos.direccion_fiscal}</li>
                                <li className="list-inline-item">
                                    {datos.codigo_postal_fiscal + " " + datos.poblacion_fiscal}
                                </li>
                                <li className="list-inline-item">{datos.nif_fiscal}</li>
                                <li className="list-inline-item">&copy; {year}</li>
                            </ul>
                        </div>

                        <div className="col-md-2">
                            <ul className="no-padding">
                                {datos.url_facebook && datos.url_facebook != "" ? <li><a href={datos.url_facebook} target="_blank"><i className="fa-brands fa-facebook"></i> Facebook</a></li> : ''}
                                {datos.url_twitter && datos.url_twitter != "" ? <li><a href={datos.url_twitter} target="_blank"><i className="fa-brands fa-twitter"></i> Twitter</a></li> : ''}
                                {datos.url_instagram && datos.url_instagram != "" ? <li><a href={datos.url_instagram} target="_blank"><i className="fa-brands fa-instagram" ></i> Instagram</a></li> : ''}
                            </ul>
                        </div>
                    </div>
                </Container>
                {
                    (logos_pie) ?
                        <Container>
                            <div className="row justify-content-center">
                                {
                                    (logos_pie.url_1 != "" && logos_pie.imagen_1 != "") ?
                                        <div className="mb-5 col-3">
                                            <a href={logos_pie.url_1} target="_blank">
                                                <img className="mx-auto img-fluid w-50 d-block" src={ruta + "/piedepagina/1/logos/1/" + logos_pie.imagen_1} />
                                            </a>
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    (logos_pie.url_2 != "" && logos_pie.imagen_2 != "") ?
                                        <div className="mb-5 col-3">
                                            <a href={logos_pie.url_2} target="_blank" >
                                                <img className="mx-auto img-fluid w-50 d-block" src={ruta + "/piedepagina/1/logos/2/" + logos_pie.imagen_2} />
                                            </a>
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    (logos_pie.url_3 != "" && logos_pie.imagen_3 != "") ?
                                        <div className="mb-5 col-3">
                                            <a href={logos_pie.url_3} target="_blank">
                                                <img className="mx-auto img-fluid w-50 d-block" src={ruta + "/piedepagina/1/logos/3/" + logos_pie.imagen_3} />
                                            </a>
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    (logos_pie.url_4 != "" && logos_pie.imagen_4 != "") ?
                                        <div className="mb-5 col-3">
                                            <a href={logos_pie.url_4} target="_blank">
                                                <img className="mx-auto img-fluid w-50 d-block" src={ruta + "/piedepagina/1/logos/4/" + logos_pie.imagen_4} />
                                            </a>
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </Container>
                        :
                        ""
                }
            </footer>
            <BotonWhatsapp
                websgrupo={datos}
            />

        </>
    );
};
export default Footer;

